var _this = this;
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import { addCallbacks, publish } from 'conversional-callbacks';
import { Events, TrackingActions, useAppDispatch } from 'conversional-journey';
import { preloadUtils } from 'conversional-utils';
// import { sendToHost, MESSAGETYPES } from 'conversional-iframe-communication'
import ExitIntentComponent from './ExitIntentComponent';
import { PreloadingContext } from '../process/PreloadingContext';
import { MESSAGETYPES, sendToHost } from 'conversional-iframe-communication';
import { AnimatePresence, motion } from 'framer-motion';
import get from 'lodash/get';
var DEFAULT_DELAY = 6000;
function defaultShouldShow() {
    return true;
}
/**
 All purpose exit intent component
 Manages triggers, fadeIn/fadeout and content rendering of exit intents
 If clicks on exit intent content need to trigger certain events (e.g. showing a journey) these actions have to be passed as callback props
 */
var ExitIntentContainer = function (props) {
    var backgroundVideo = props.backgroundVideo, callbacks = props.callbacks, children = props.children, componentKey = props.componentKey, delay = props.delay, image = props.image, isInternal = props.isInternal, backdropStyles = props.backdropStyles, overlayStyles = props.overlayStyles, contentStyles = props.contentStyles, onClick = props.onClick, onClose = props.onClose, onTrigger = props.onTrigger, open = props.open, pageTitle = props.pageTitle, _a = props.shouldShow, shouldShow = _a === void 0 ? defaultShouldShow : _a;
    var preloading = useContext(PreloadingContext).preloading;
    if (preloading)
        return null;
    var dispatch = useAppDispatch();
    var trackEvent = function (event) { return dispatch(TrackingActions.event(event)); };
    var _b = useState(props.show), show = _b[0], setShow = _b[1];
    var _c = useState(false), showModal = _c[0], setShowModal = _c[1];
    // TODO: Establish on leave site listener for out-of-iframe events
    React.useEffect(function () {
        if (!shouldShow(componentKey) && !isInternal) {
            onClose(componentKey);
            return;
        }
        if (backgroundVideo) {
            preloadUtils.preloadVideo(backgroundVideo, {
                id: 'exitintent_preload_background',
            });
        }
        if (image) {
            preloadUtils.preloadImages([image]);
        }
        window.exitIntentPageTitle = pageTitle;
        var supportedCallbacks = {
            openJourneyCallback: click, // for backward-compatibility, still used in configuration
            onTriggerCallback: click,
            onCloseCallback: close,
        };
        addCallbacks(_this, callbacks || {}, supportedCallbacks);
        setTimeout(function () { return sendToHost.subscribe(MESSAGETYPES.ON_EXIT, function () { return trigger(); }); }, delay || DEFAULT_DELAY);
        // return () => {
        /**
         * When using multiple internal exit intents the unsubscribe callback will cause the second internal exit intent to unmount short after loading.
         * The reason for this behaviour is not clear yet, therefore the unsubscribe was temporarily deactivated.
         */
        // sendToHost.unsubscribe(MESSAGETYPES.ON_EXIT, onExitCallback)
        //   }
    }, []);
    useEffect(function () {
        if (open) {
            trigger(true);
        }
    }, [open]);
    useEffect(function () {
        if (show) {
            trigger();
            window.addEventListener('keydown', closeOnEsc);
            return function () {
                window.removeEventListener('keydown', closeOnEsc);
            };
        }
    }, [show]);
    var closeOnEsc = function (evt) {
        if (!show) {
            return;
        }
        evt = evt || window.event;
        var isEscape = false;
        if ('key' in evt) {
            isEscape = evt.key === 'Escape' || evt.key === 'Esc';
        }
        else {
            isEscape = get(evt, 'code') === '27';
        }
        if (isEscape) {
            evt.preventDefault(); // Makes sure only exit intent closes, not the containing modal, e.g. for using in-result exit intents
            close();
        }
    };
    var trigger = function (force) {
        if (shouldShow(componentKey) || force) {
            onTrigger(componentKey);
            publish("ExitIntent.shown.".concat(componentKey));
            trackEvent(Events.EXITINTENT_OPEN);
            setShow(true);
            setTimeout(function () { return setShowModal(true); }, 1);
        }
    };
    // will automatically trigger hide after exit animation through PoseJS
    var close = function () {
        setShowModal(false);
    };
    var hide = function () {
        onClose(componentKey);
        publish("ExitIntent.closed.".concat(componentKey));
        trackEvent(Events.EXITINTENT_CLOSE);
        setShow(false);
    };
    var click = function () {
        onClick(componentKey);
        publish("ExitIntent.clicked.".concat(componentKey));
        trackEvent(Events.EXITINTENT_OPEN);
    };
    var variants = {
        hidden: {
            opacity: 0,
        },
        show: {
            transition: {
                duration: 0.3,
                ease: [0.465, 0.183, 0.153, 0.946],
            },
            opacity: 1,
        },
        exit: {
            transition: {
                duration: 0.2,
                ease: [0.465, 0.183, 0.153, 0.946],
            },
            opacity: 0,
        },
    };
    return (_jsx(React.Fragment, { children: _jsx(AnimatePresence, { onExitComplete: hide, children: show && showModal && _jsx(motion.div, { animate: "show", exit: "exit", variants: variants, children: _jsx(ExitIntentComponent, { backdrop: props.backdrop, hideCloseButton: props.hideCloseButton, close: close, display: props.image, htmlId: props.htmlId, onClick: click, backdropStyles: backdropStyles, overlayStyles: overlayStyles, contentStyles: contentStyles, backgroundVideo: props.backgroundVideo, showModal: preloading || showModal, isInternal: isInternal, children: children }) }, "conversional-exit-intent-".concat(componentKey)) }) }));
};
ExitIntentContainer.defaultProps = {
    onClick: function () { },
    onClose: function () { },
    onTrigger: function () { },
    show: false,
    backdrop: 'rgba(142,142,142,0.75)',
    id: ''
};
export default ExitIntentContainer;
